<template>
  <svg viewBox="-1 -1 21 21">
    <path
      fill="currentColor"
      d="M9 9h-9v-6a3 3 90 0 1 3 -3h6M10 9v-9h6a3 3 90 0 1 3 3v6M10 10h9v6a3 3 90 0 1 -3 3h-6M9 10v9h-6a3 3 90 0 1 -3 -3v-6"
    />
    <g>
      <ellipse rx="2.1" ry="2.1" cx="4.5" cy="4.5" stroke="#fd6767" />
      <rect width="3.6" height="3.6" y="2.8" x="12.8" stroke="#fd68f8" />
      <path d="m14.5 13 2 3.4h-4z" stroke="#3fe1a0" />
      <path transform="rotate(45 4.5 14.5)" d="M2 14h2v-2h1v2h2v1h-2v2h-1v-2h-2" fill="#7cb1e7" />
    </g>
    <g>
      <path
        d="M2 4h2v-2h1v2h2v1h-2v2h-1v-2h-2M12.5 4h4v1h-4M12 14h5v1h-5 M14.5 11.8
        a0.8 0.8 180 0 1 0 1.6a0.8 0.8 180 0 1 0 -1.6m0 3.8a0.8 0.8 180 0 1 0 1.6a0.8 0.8 180 0 1 0 -1.6"
      />
      <path transform="rotate(45 4.5 14.5)" d="M2 14h2v-2h1v2h2v1h-2v2h-1v-2h-2" />
    </g>
  </svg>
</template>

<style scoped>
svg {
  width: 1.1em;
  height: 1.1em;
  vertical-align: bottom;
}

g:first-of-type {
  display: none;
  fill: none;
}

g:last-of-type {
  fill: white;
}
</style>
